import styled from 'styled-components';

export const StyledProduct = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  height: 158px;
  border-radius: 16px;

  img {
    width: 98%;
    height: 154px;
    object-fit: contain;
    filter: drop-shadow(0 0 0.75rem rgb(255, 255, 255, 0.5));
  }
`;

export const StyledProductText = styled.div`
  font-size: 24px;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-right: 5px;
  width: 100%;
  margin-top: 12px;

  &:last-child {
    margin-right: 0;
  }

  img {
    height: 20px;
    width: 20px;
  }

  .quantity-wrapper {
    max-width: calc(100% - 24px);

    .quantity {
      background: -webkit-linear-gradient(#fde60a 18.75%, #fefe00 81.25%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      position: relative;

      &:after {
        background: none;
        content: attr(data-main);
        left: 0;
        top: 0;
        z-index: -1;
        position: absolute;
        text-shadow: 1px 1px 1px #8c0000, -1px -1px 1px #8c0000,
          1px -1px 1px #8c0000, -1px 1px 1px #8c0000;
      }
    }
  }
`;
